// extracted by mini-css-extract-plugin
export default {"backgroundColor":"Theme_backgroundColor__v1tq+"};